import styled from 'styled-components';

export const ToastMessageContainer = styled.div`
`;
